import RESTSerializer from '@ember-data/serializer/rest';
import { underscore } from '@ember/string';
import { isNone } from '@ember/utils';
export default class BaseRestSerializer extends RESTSerializer {
  // allows us to set `{ readOnly: true }` in an attribute
  // to not have it sent to the server.
  serializeAttribute(snapshot, json, key, attribute) {
    // do not serialize the attribute!
    if (attribute.options && attribute.options.readOnly) {
      return;
    }
    super.serializeAttribute(snapshot, json, key, attribute);
  }
  keyForAttribute(attr) {
    return underscore(attr);
  }
  keyForRelationship(key) {
    return underscore(key);
  }
  payloadKeyFromModelName(modelName) {
    if (this.rootKey) {
      return this.rootKey;
    }
    return underscore(modelName);
  }
  modelNameFromPayloadKey(payloadKey) {
    if (this.collectionKey && payloadKey === this.collectionKey || this.rootKey && payloadKey === this.rootKey) {
      return this.modelName;
    }
    return super.modelNameFromPayloadKey(payloadKey);
  }
  normalizeQueryResponse(store, primaryModelClass, payload, id, requestType) {
    if (isNone(payload[this.collectionKey])) {
      // eslint-disable-next-line no-param-reassign
      payload[this.collectionKey] = [];
    }
    return super.normalizeQueryResponse(store, primaryModelClass, payload, id, requestType);
  }
}